

// import { useState, useEffect } from "react"
// import { Link, useNavigate } from "react-router-dom"
// import { baseUrl } from "../../config/baseUrl"
// import axios from "axios"
// import toastify from "../../config/toastify"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import { faArrowLeft, faBoxOpen, faSave, faUpload, faTimes } from "@fortawesome/free-solid-svg-icons"
// import JoditEditor from "jodit-react";
// import editorConfig from "../../utils/editorConfig";
// export default function AddPackage() {
//     const [formval, setFormval] = useState({
//         title: "",
//         description: "",
//         price: "",
//         offerPrice: "",
//         status: "",
//         subcategoryID: "",
//         categoryID: "",
//         validity: "",
//     })

//     const [selectedFile, setSelectedFile] = useState(null)
//     const [previewUrl, setPreviewUrl] = useState(null)
//     const [isDragging, setIsDragging] = useState(false)
//     const [loading, setLoading] = useState(false)
//     const [subcategories, setSubcategories] = useState([])

//     const navigate = useNavigate()

//     const changeHandler = (e) => {
//         const { name, value } = e.target
//         setFormval((prevVal) => ({
//             ...prevVal,
//             [name]: value,
//         }))
//     }
//     const handleQuillChange = (value) => {
//         setFormval((prevVal) => ({
//             ...prevVal,
//             description: value,
//         }));
//     };


//     const handleFileChange = (e) => {
//         const file = e.target.files[0]
//         if (file) {
//             setSelectedFile(file)
//             const reader = new FileReader()
//             reader.onload = () => {
//                 setPreviewUrl(reader.result)
//             }
//             reader.readAsDataURL(file)
//         }
//     }

//     const handleDragOver = (e) => {
//         e.preventDefault()
//         setIsDragging(true)
//     }

//     const handleDragLeave = () => {
//         setIsDragging(false)
//     }

//     const handleDrop = (e) => {
//         e.preventDefault()
//         setIsDragging(false)

//         if (e.dataTransfer.files && e.dataTransfer.files[0]) {
//             const file = e.dataTransfer.files[0]
//             setSelectedFile(file)
//             const reader = new FileReader()
//             reader.onload = () => {
//                 setPreviewUrl(reader.result)
//             }
//             reader.readAsDataURL(file)
//         }
//     }

//     const removeFile = () => {
//         setSelectedFile(null)
//         setPreviewUrl(null)
//     }

//     const handleSubmit = async (e) => {
//         e.preventDefault()

//         // Form validation
//         if (!formval.title) {
//             return toastify.error("Title is required")
//         }
//         if (!formval.description) {
//             return toastify.error("Description is required")
//         }
//         if (!formval.price) {
//             return toastify.error("Price is required")
//         }
//         if (!formval.status) {
//             return toastify.error("Status is required")
//         }
//         if (!formval.subcategoryID) {
//             return toastify.error("Subcategory is required")
//         }
//         if (!formval.categoryID) {
//             return toastify.error("Category is required")
//         }

//         setLoading(true)

//         try {
//             const formData = new FormData()

//             // Append all form fields
//             Object.keys(formval).forEach((key) => {
//                 formData.append(key, formval[key])
//             })

//             // Append image if selected
//             if (selectedFile) {
//                 formData.append("image", selectedFile)
//             }

//             const response = await axios(`${baseUrl}/package`, {
//                 method: "POST",
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                 },
//                 data: formData,
//             })

//             if (!response?.data?.status) {
//                 toastify.error("An error occurred while creating package")
//                 return
//             }

//             toastify.success("Package created successfully")
//             navigate("/test-packages")
//         } catch (error) {
//             console.error("Error:", error)
//             toastify.error("Failed to create package")
//         } finally {
//             setLoading(false)
//         }
//     }
//     const [categories, setCategories] = useState([])
//     const fetchCategories = async () => {
//         try {
//             const response = await axios.get(`${baseUrl}/category`, {
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                 },
//             })
//             setCategories(response.data.data)
//         } catch (error) {
//             console.error("Error fetching subcategories:", error)
//         }
//     }
//     const fetchSubcategories = async () => {
//         try {
//             const response = await axios.get(`${baseUrl}/subcategory`, {
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                 },
//             })
//             setSubcategories(response.data.data)
//         } catch (error) {
//             console.error("Error fetching subcategories:", error)
//         }
//     }

//     useEffect(() => {
//         fetchSubcategories()
//         fetchCategories()
//     }, [])

//     const filteredSubCat = formval.categoryID
//         ? subcategories.filter((subcat) => subcat?.categoryId?._id === formval.categoryID)
//         : subcategories;
//     return (
//         <>
//             <style >{`
//         .main-sec {
//           background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
//           min-height: 100vh;
//           padding: 2rem 0;
//         }

//         .dashboard-title {
//           margin-bottom: 1.5rem;
//         }

//         .dash-head {
//           color: #333;
//           font-size: 1.8rem;
//           font-weight: 700;
//           margin: 0;
//         }

//         .cards {
//           background: white;
//           border-radius: 15px;
//           padding: 2rem;
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//           margin-bottom: 2rem;
//         }

//         .form-label {
//           font-weight: 600;
//           color: #555;
//           margin-bottom: 0.5rem;
//         }

//         .form-control {
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           padding: 0.75rem 1rem;
//           transition: all 0.3s ease;
//         }

//         .form-control:focus {
//           border-color: #7436A9;
//           box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.25);
//         }

//         .form-section {
//           background: #f8f9ff;
//           border-radius: 10px;
//           padding: 1.5rem;
//           margin-bottom: 2rem;
//           border-left: 4px solid #7436A9;
//         }

//         .section-title {
//           color: #7436A9;
//           font-weight: 700;
//           margin-bottom: 1rem;
//           font-size: 1.1rem;
//         }

//         .file-upload-container {
//           margin-bottom: 1.5rem;
//         }

//         .file-upload-area {
//           border: 2px dashed #ddd;
//           border-radius: 10px;
//           padding: 2rem;
//           text-align: center;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           position: relative;
//         }

//         .file-upload-area.dragging {
//           border-color: #7436A9;
//           background: rgba(102, 126, 234, 0.1);
//         }

//         .file-upload-area:hover {
//           border-color: #7436A9;
//         }

//         .file-upload-icon {
//           font-size: 3rem;
//           color: #7436A9;
//           margin-bottom: 1rem;
//         }

//         .file-upload-text {
//           font-size: 1.1rem;
//           font-weight: 600;
//           color: #333;
//           margin-bottom: 0.5rem;
//         }

//         .file-upload-subtext {
//           color: #666;
//           font-size: 0.9rem;
//         }

//         .file-upload-input {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           opacity: 0;
//           cursor: pointer;
//         }

//         .file-preview-container {
//           position: relative;
//           display: inline-block;
//         }

//         .file-preview {
//           max-width: 200px;
//           max-height: 200px;
//           border-radius: 10px;
//           box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
//         }

//         .file-remove-btn {
//           position: absolute;
//           top: -10px;
//           right: -10px;
//           background: #ef5350;
//           color: white;
//           border: none;
//           border-radius: 50%;
//           width: 30px;
//           height: 30px;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .file-info {
//           margin-top: 1rem;
//           font-size: 0.9rem;
//           color: #666;
//         }

//         .btn-for-add {
//           background: linear-gradient(135deg, #7436A9 0%, #764ba2 100%);
//           border: none;
//           border-radius: 8px;
//           padding: 0.75rem 2rem;
//           font-weight: 600;
//           transition: all 0.3s ease;
//           color: white;
//         }

//         .btn-for-add:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
//         }

//         .btn-for-add:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//           transform: none;
//         }

//         .btn-info {
//           background: #4facfe;
//           border: none;
//           border-radius: 8px;
//           padding: 0.75rem 1.5rem;
//           font-weight: 600;
//           transition: all 0.3s ease;
//         }

//         .btn-info:hover {
//           background: #2f86fe;
//           transform: translateY(-2px);
//           box-shadow: 0 10px 20px rgba(79, 172, 254, 0.3);
//         }

//         .loading-spinner {
//           width: 20px;
//           height: 20px;
//           border: 2px solid #f3f3f3;
//           border-top: 2px solid #7436A9;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//           margin-right: 0.5rem;
//         }

//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         @media (max-width: 768px) {
//           .cards {
//             padding: 1.5rem;
//           }

//           .form-section {
//             padding: 1rem;
//           }
//         }
//       `}</style>

//             <section className="main-sec">
//                 <div className="container">
//                     <div className="row align-items-center">
//                         <div className="col-lg-6">
//                             <div className="dashboard-title">
//                                 <h4 className="dash-head">
//                                     <FontAwesomeIcon icon={faBoxOpen} className="me-2" />
//                                     Add Package
//                                 </h4>
//                             </div>
//                             <div className="custom-bredcump">
//                                 <nav aria-label="breadcrumb">
//                                     <ol className="breadcrumb">
//                                         <li className="breadcrumb-item">
//                                             <Link to="/">Dashboard</Link>
//                                         </li>
//                                         <li className="breadcrumb-item">
//                                             <Link to="/packages">Packages</Link>
//                                         </li>
//                                         <li className="breadcrumb-item active" aria-current="page">
//                                             Add Package
//                                         </li>
//                                     </ol>
//                                 </nav>
//                             </div>
//                         </div>
//                         <div className="col-lg-6 d-flex justify-content-end">
//                             <Link to="/test-packages" className="btn btn-info text-white">
//                                 <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
//                                 Back
//                             </Link>
//                         </div>
//                     </div>

//                     <div className="row">
//                         <div className="col-lg-12">
//                             <div className="cards edit-usr">
//                                 <form onSubmit={handleSubmit}>
//                                     {/* Basic Information */}
//                                     <div className="form-section">
//                                         <h5 className="section-title">Package Details</h5>
//                                         <div className="row">
//                                             <div className="col-lg-6 mb-4">
//                                                 <label htmlFor="title" className="form-label">
//                                                     Title<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control"
//                                                     name="title"
//                                                     placeholder="Enter package title"
//                                                     onChange={changeHandler}
//                                                     value={formval?.title}
//                                                 />
//                                             </div>
//                                             <div className="col-lg-6 mb-4">
//                                                 <label htmlFor="price" className="form-label">
//                                                     Price (₹)<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <input
//                                                     type="number"
//                                                     className="form-control"
//                                                     name="price"
//                                                     placeholder="Enter price"
//                                                     onChange={changeHandler}
//                                                     value={formval?.price}
//                                                 />
//                                             </div>
//                                             <div className="col-lg-6 mb-4">
//                                                 <label htmlFor="offerPrice" className="form-label">
//                                                     Offer Price (₹)
//                                                 </label>
//                                                 <input
//                                                     type="number"
//                                                     className="form-control"
//                                                     name="offerPrice"
//                                                     placeholder="Enter offer price"
//                                                     onChange={changeHandler}
//                                                     value={formval?.offerPrice}
//                                                 />
//                                             </div>
//                                             <div className="col-lg-6 mb-4">
//                                                 <label htmlFor="validity" className="form-label">
//                                                     Validity (in days)
//                                                 </label>
//                                                 <input
//                                                     type="number"
//                                                     className="form-control"
//                                                     name="validity"
//                                                     placeholder="Enter Validity (Eg: 7 days)"
//                                                     onChange={changeHandler}
//                                                     value={formval?.validity}
//                                                 />
//                                             </div>
//                                             <div className="col-lg-12 mb-4">
//                                                 <label htmlFor="description" className="form-label">
//                                                     Description<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <JoditEditor
//                                                     value={formval?.description || ""}
//                                                     config={{
//                                                         ...editorConfig,
//                                                         placeholder: "Enter test description",
//                                                     }}
//                                                     onChange={(value) => {
//                                                         let content = value;
//                                                         const youtubeRegex =
//                                                             /https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{6,})[^\s]*/g;
//                                                         content = content.replace(youtubeRegex, (match, videoId) => {
//                                                             return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
//                                                         });
//                                                         setFormval(prev => ({
//                                                             ...prev,
//                                                             description: content,
//                                                         }));
//                                                     }}
//                                                 />

//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* Package Image */}
//                                     <div className="form-section">
//                                         <h5 className="section-title">Package Image</h5>
//                                         <div className="file-upload-container">
//                                             <div
//                                                 className={`file-upload-area ${isDragging ? "dragging" : ""}`}
//                                                 onDragOver={handleDragOver}
//                                                 onDragLeave={handleDragLeave}
//                                                 onDrop={handleDrop}
//                                             >
//                                                 {!selectedFile ? (
//                                                     <>
//                                                         <div className="file-upload-icon">
//                                                             <FontAwesomeIcon icon={faUpload} />
//                                                         </div>
//                                                         <div className="file-upload-text">Drag & Drop your image here</div>
//                                                         <div className="file-upload-subtext">or click to browse files</div>
//                                                         <input
//                                                             type="file"
//                                                             className="file-upload-input"
//                                                             accept="image/*"
//                                                             onChange={handleFileChange}
//                                                         />
//                                                     </>
//                                                 ) : (
//                                                     <div className="file-preview-container">
//                                                         <img src={previewUrl || "/placeholder.svg"} alt="Preview" className="file-preview" />
//                                                         <button type="button" className="file-remove-btn" onClick={removeFile}>
//                                                             <FontAwesomeIcon icon={faTimes} />
//                                                         </button>
//                                                         <div className="file-info">
//                                                             {selectedFile.name} ({Math.round(selectedFile.size / 1024)} KB)
//                                                         </div>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="form-section">
//                                         <h5 className="section-title">Category Selection</h5>
//                                         <div className="row">
//                                             <div className="col-lg-6 mb-4">
//                                                 <label htmlFor="subcategoryID" className="form-label">
//                                                     Category<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <select
//                                                     className="form-control"
//                                                     name="categoryID"
//                                                     onChange={changeHandler}
//                                                     value={formval?.categoryID}
//                                                 >
//                                                     <option value="">Select Category</option>
//                                                     {categories.map((cat) => (
//                                                         <option key={cat._id} value={cat._id}>
//                                                             {cat?.title}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                             </div>
//                                             <div className="col-lg-6 mb-4">
//                                                 <label htmlFor="subcategoryID" className="form-label">
//                                                     Subcategory<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <select
//                                                     className="form-control"
//                                                     name="subcategoryID"
//                                                     onChange={changeHandler}
//                                                     value={formval?.subcategoryID}
//                                                 >
//                                                     <option value="">Select Subcategory</option>
//                                                     {filteredSubCat.map((subcat) => (
//                                                         <option key={subcat._id} value={subcat._id}>
//                                                             {subcat.title}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* Status */}
//                                     <div className="form-section">
//                                         <h5 className="section-title">Status</h5>
//                                         <div className="row">
//                                             <div className="col-lg-6 mb-4">
//                                                 <label htmlFor="status" className="form-label">
//                                                     Status<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <select className="form-control" name="status" onChange={changeHandler} value={formval?.status}>
//                                                     <option value="">Select Status</option>
//                                                     <option value="active">Active</option>
//                                                     <option value="inactive">Inactive</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-lg-12 text-center mt-4">
//                                         <button type="submit" className="btn btn-for-add text-white" disabled={loading}>
//                                             {loading && <div className="loading-spinner"></div>}
//                                             <FontAwesomeIcon icon={faSave} className="me-2" />
//                                             {loading ? "Creating..." : "Create Package"}
//                                         </button>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     )
// }


import { useState, useEffect, useMemo } from "react"
import { Link, useNavigate } from "react-router-dom"
import { baseUrl } from "../../config/baseUrl"
import axios from "axios"
import toastify from "../../config/toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faBoxOpen, faSave, faUpload, faTimes } from "@fortawesome/free-solid-svg-icons"
import JoditEditor from "jodit-react";
import editorConfig from "../../utils/editorConfig";
export default function AddPackage() {
    const [formval, setFormval] = useState({
        title: "",
        description: "",
        price: "",
        offerPrice: "",
        status: "",
        subcategoryID: "",
        categoryID: "",
        validity: "",
    })

    const [selectedFile, setSelectedFile] = useState(null)
    const [previewUrl, setPreviewUrl] = useState(null)
    const [isDragging, setIsDragging] = useState(false)
    const [loading, setLoading] = useState(false)
    const [subcategories, setSubcategories] = useState([])

    const navigate = useNavigate()

    const changeHandler = (e) => {
        const { name, value } = e.target
        setFormval((prevVal) => ({
            ...prevVal,
            [name]: value,
        }))
    }
    const handleQuillChange = (value) => {
        setFormval((prevVal) => ({
            ...prevVal,
            description: value,
        }));
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0]
        if (file) {
            setSelectedFile(file)
            const reader = new FileReader()
            reader.onload = () => {
                setPreviewUrl(reader.result)
            }
            reader.readAsDataURL(file)
        }
    }

    const handleDragOver = (e) => {
        e.preventDefault()
        setIsDragging(true)
    }

    const handleDragLeave = () => {
        setIsDragging(false)
    }

    const handleDrop = (e) => {
        e.preventDefault()
        setIsDragging(false)

        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const file = e.dataTransfer.files[0]
            setSelectedFile(file)
            const reader = new FileReader()
            reader.onload = () => {
                setPreviewUrl(reader.result)
            }
            reader.readAsDataURL(file)
        }
    }

    const removeFile = () => {
        setSelectedFile(null)
        setPreviewUrl(null)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        // Form validation
        if (!formval.title) {
            return toastify.error("Title is required")
        }
        if (!formval.description) {
            return toastify.error("Description is required")
        }
        if (!formval.price) {
            return toastify.error("Price is required")
        }
        if (!formval.status) {
            return toastify.error("Status is required")
        }
        if (!formval.subcategoryID) {
            return toastify.error("Subcategory is required")
        }
        if (!formval.categoryID) {
            return toastify.error("Category is required")
        }

        setLoading(true)

        try {
            const formData = new FormData()

            // Append all form fields
            Object.keys(formval).forEach((key) => {
                formData.append(key, formval[key])
            })

            // Append image if selected
            if (selectedFile) {
                formData.append("image", selectedFile)
            }

            const response = await axios(`${baseUrl}/package`, {
                method: "POST",
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
                data: formData,
            })

            if (!response?.data?.status) {
                toastify.error("An error occurred while creating package")
                return
            }

            toastify.success("Package created successfully")
            navigate("/test-packages")
        } catch (error) {
            console.error("Error:", error)
            toastify.error("Failed to create package")
        } finally {
            setLoading(false)
        }
    }
    const [categories, setCategories] = useState([])
    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${baseUrl}/category`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
            })
            setCategories(response.data.data)
        } catch (error) {
            console.error("Error fetching subcategories:", error)
        }
    }
    const fetchSubcategories = async () => {
        try {
            const response = await axios.get(`${baseUrl}/subcategory`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
            })
            setSubcategories(response.data.data)
        } catch (error) {
            console.error("Error fetching subcategories:", error)
        }
    }

    useEffect(() => {
        fetchSubcategories()
        fetchCategories()
    }, [])

    const filteredSubCat = formval.categoryID
        ? subcategories.filter((subcat) => subcat?.categoryId?._id === formval.categoryID)
        : subcategories;


    const config = useMemo(() => ({
        ...editorConfig,
        placeholder: "Enter test description",
    }), []);


    return (
        <>
            <style >{`
        .main-sec {
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          min-height: 100vh;
          padding: 2rem 0;
        }

        .dashboard-title {
          margin-bottom: 1.5rem;
        }

        .dash-head {
          color: #333;
          font-size: 1.8rem;
          font-weight: 700;
          margin: 0;
        }

        .cards {
          background: white;
          border-radius: 15px;
          padding: 2rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          margin-bottom: 2rem;
        }

        .form-label {
          font-weight: 600;
          color: #555;
          margin-bottom: 0.5rem;
        }

        .form-control {
          border-radius: 8px;
          border: 1px solid #ddd;
          padding: 0.75rem 1rem;
          transition: all 0.3s ease;
        }

        .form-control:focus {
          border-color: #7436A9;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.25);
        }

        .form-section {
          background: #f8f9ff;
          border-radius: 10px;
          padding: 1.5rem;
          margin-bottom: 2rem;
          border-left: 4px solid #7436A9;
        }

        .section-title {
          color: #7436A9;
          font-weight: 700;
          margin-bottom: 1rem;
          font-size: 1.1rem;
        }

        .file-upload-container {
          margin-bottom: 1.5rem;
        }

        .file-upload-area {
          border: 2px dashed #ddd;
          border-radius: 10px;
          padding: 2rem;
          text-align: center;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
        }

        .file-upload-area.dragging {
          border-color: #7436A9;
          background: rgba(102, 126, 234, 0.1);
        }

        .file-upload-area:hover {
          border-color: #7436A9;
        }

        .file-upload-icon {
          font-size: 3rem;
          color: #7436A9;
          margin-bottom: 1rem;
        }

        .file-upload-text {
          font-size: 1.1rem;
          font-weight: 600;
          color: #333;
          margin-bottom: 0.5rem;
        }

        .file-upload-subtext {
          color: #666;
          font-size: 0.9rem;
        }

        .file-upload-input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          cursor: pointer;
        }

        .file-preview-container {
          position: relative;
          display: inline-block;
        }

        .file-preview {
          max-width: 200px;
          max-height: 200px;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        }

        .file-remove-btn {
          position: absolute;
          top: -10px;
          right: -10px;
          background: #ef5350;
          color: white;
          border: none;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .file-info {
          margin-top: 1rem;
          font-size: 0.9rem;
          color: #666;
        }

        .btn-for-add {
          background: linear-gradient(135deg, #7436A9 0%, #764ba2 100%);
          border: none;
          border-radius: 8px;
          padding: 0.75rem 2rem;
          font-weight: 600;
          transition: all 0.3s ease;
          color: white;
        }

        .btn-for-add:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
        }

        .btn-for-add:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .btn-info {
          background: #4facfe;
          border: none;
          border-radius: 8px;
          padding: 0.75rem 1.5rem;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .btn-info:hover {
          background: #2f86fe;
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(79, 172, 254, 0.3);
        }

        .loading-spinner {
          width: 20px;
          height: 20px;
          border: 2px solid #f3f3f3;
          border-top: 2px solid #7436A9;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-right: 0.5rem;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @media (max-width: 768px) {
          .cards {
            padding: 1.5rem;
          }
          
          .form-section {
            padding: 1rem;
          }
        }
      `}</style>

            <section className="main-sec">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="dashboard-title">
                                <h4 className="dash-head">
                                    <FontAwesomeIcon icon={faBoxOpen} className="me-2" />
                                    Add Package
                                </h4>
                            </div>
                            <div className="custom-bredcump">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/packages">Packages</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Add Package
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-end">
                            <Link to="/test-packages" className="btn btn-info text-white">
                                <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                                Back
                            </Link>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cards edit-usr">
                                <form onSubmit={handleSubmit}>
                                    {/* Basic Information */}
                                    <div className="form-section">
                                        <h5 className="section-title">Package Details</h5>
                                        <div className="row">
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="title" className="form-label">
                                                    Title<sup className="text-danger">*</sup>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="title"
                                                    placeholder="Enter package title"
                                                    onChange={changeHandler}
                                                    value={formval?.title}
                                                />
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="price" className="form-label">
                                                    Price (₹)<sup className="text-danger">*</sup>
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="price"
                                                    placeholder="Enter price"
                                                    onChange={changeHandler}
                                                    value={formval?.price}
                                                />
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="offerPrice" className="form-label">
                                                    Offer Price (₹)
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="offerPrice"
                                                    placeholder="Enter offer price"
                                                    onChange={changeHandler}
                                                    value={formval?.offerPrice}
                                                />
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="validity" className="form-label">
                                                    Validity (in days)
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="validity"
                                                    placeholder="Enter Validity (Eg: 7 days)"
                                                    onChange={changeHandler}
                                                    value={formval?.validity}
                                                />
                                            </div>
                                            <div className="col-lg-12 mb-4">
                                                <label htmlFor="description" className="form-label">
                                                    Description<sup className="text-danger">*</sup>
                                                </label>
                                                <JoditEditor
                                                    value={formval?.description || ""}
                                                    config={config} // Yahan change kiya hai
                                                    tabIndex={1} // Optional: Focus maintain karne me help karta hai
                                                    onBlur={(newContent) => {
                                                        // Performance improve karne ke liye heavy logic onBlur par bhi shift kar sakte hain
                                                        // lekin agar aapko realtime chahiye toh onChange thik hai
                                                    }}
                                                    onChange={(value) => {
                                                        let content = value;
                                                        const youtubeRegex =
                                                            /https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{6,})[^\s]*/g;
                                                        content = content.replace(youtubeRegex, (match, videoId) => {
                                                            return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
                                                        });

                                                        // State update karein
                                                        setFormval(prev => ({
                                                            ...prev,
                                                            description: content,
                                                        }));
                                                    }}
                                                />

                                            </div>
                                        </div>
                                    </div>

                                    {/* Package Image */}
                                    <div className="form-section">
                                        <h5 className="section-title">Package Image</h5>
                                        <div className="file-upload-container">
                                            <div
                                                className={`file-upload-area ${isDragging ? "dragging" : ""}`}
                                                onDragOver={handleDragOver}
                                                onDragLeave={handleDragLeave}
                                                onDrop={handleDrop}
                                            >
                                                {!selectedFile ? (
                                                    <>
                                                        <div className="file-upload-icon">
                                                            <FontAwesomeIcon icon={faUpload} />
                                                        </div>
                                                        <div className="file-upload-text">Drag & Drop your image here</div>
                                                        <div className="file-upload-subtext">or click to browse files</div>
                                                        <input
                                                            type="file"
                                                            className="file-upload-input"
                                                            accept="image/*"
                                                            onChange={handleFileChange}
                                                        />
                                                    </>
                                                ) : (
                                                    <div className="file-preview-container">
                                                        <img src={previewUrl || "/placeholder.svg"} alt="Preview" className="file-preview" />
                                                        <button type="button" className="file-remove-btn" onClick={removeFile}>
                                                            <FontAwesomeIcon icon={faTimes} />
                                                        </button>
                                                        <div className="file-info">
                                                            {selectedFile.name} ({Math.round(selectedFile.size / 1024)} KB)
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-section">
                                        <h5 className="section-title">Category Selection</h5>
                                        <div className="row">
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="subcategoryID" className="form-label">
                                                    Category<sup className="text-danger">*</sup>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="categoryID"
                                                    onChange={changeHandler}
                                                    value={formval?.categoryID}
                                                >
                                                    <option value="">Select Category</option>
                                                    {categories.map((cat) => (
                                                        <option key={cat._id} value={cat._id}>
                                                            {cat?.title}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="subcategoryID" className="form-label">
                                                    Subcategory<sup className="text-danger">*</sup>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="subcategoryID"
                                                    onChange={changeHandler}
                                                    value={formval?.subcategoryID}
                                                >
                                                    <option value="">Select Subcategory</option>
                                                    {filteredSubCat.map((subcat) => (
                                                        <option key={subcat._id} value={subcat._id}>
                                                            {subcat.title}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Status */}
                                    <div className="form-section">
                                        <h5 className="section-title">Status</h5>
                                        <div className="row">
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="status" className="form-label">
                                                    Status<sup className="text-danger">*</sup>
                                                </label>
                                                <select className="form-control" name="status" onChange={changeHandler} value={formval?.status}>
                                                    <option value="">Select Status</option>
                                                    <option value="active">Active</option>
                                                    <option value="inactive">Inactive</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-12 text-center mt-4">
                                        <button type="submit" className="btn btn-for-add text-white" disabled={loading}>
                                            {loading && <div className="loading-spinner"></div>}
                                            <FontAwesomeIcon icon={faSave} className="me-2" />
                                            {loading ? "Creating..." : "Create Package"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
